/* 馬超傳・第 6 章：成都（214 年）
 * 成都在南邊，方城、北面一座城門。馬超從北邊的大路下來，城北是一片平地，可以列陣。 */
export const CITY = { x: 4000, y: 3500, hw: 1100, hh: 700 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw, G = 130;
export const GATE = [CITY.x, N], START = [4000, 500];
// 城外列陣的地方：西北、北門前、東北、西、東
export const SPOTS = [[2500, 2300, '西北'], [4000, 2150, '北門前'], [5500, 2300, '東北'], [2400, 3300, '城西'], [5600, 3300, '城東']];
export default {
  id: 'machao_chengdu', name: '成都', W: 8000, H: 4800, seed: 214,
  bases: [START, [CITY.x, CITY.y]],
  walls: [[CITY.x, S, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh], [E, CITY.y, T, CITY.hh], [(Wx + GATE[0] - G) / 2, N, (GATE[0] - G - Wx) / 2 + T, T], [(GATE[0] + G + E) / 2, N, (E - GATE[0] - G) / 2 + T, T]],
  roads: [{ pts: [START, [4000, 1600], GATE, [CITY.x, CITY.y]], w: 150 }, { pts: [[2500, 2300], [4000, 2150], [5500, 2300]], w: 110 }],
  rocks: [[1200, 1200, 420, 200], [6800, 1200, 420, 200], [1000, 4200, 380, 180], [7000, 4200, 380, 180]],
  woods: 0.35,
  sight: 0.85,
  clearings: [[CITY.x, CITY.y, 1200], [4000, 2200, 900], [2450, 3000, 450], [5550, 3000, 450], [START[0], START[1] + 100, 400]],
  villages: [{ x: CITY.x, y: CITY.y + 40, n: 12, r: 640 }],
  fields: [[2000, 1800, 560, 260], [6000, 1800, 560, 260, '#86803f']],
};
